module.exports = __webpack_public_path__ + "static/media/illustration-support@3x.ddc64cec.png";